import React from 'react';
import { useAppSelector } from 'src/store';
import HastaUyariListesi from './Liste';
import HastaUyariEkle from './Ekle';

const HastaUyariEkrani = (): JSX.Element => {
    const state = useAppSelector(s => s.hastaUyari);
    return (
        <>
            {state.open && <HastaUyariListesi />}
            {state.ekleOpen && <HastaUyariEkle />}
        </>
    );
};

export default HastaUyariEkrani;